module.exports = require('./helpers/bundle-url').getBundleURL('deub8') + "logo.c51670a8.svg";